// removed by extract-text-webpack-plugin
module.exports = {"courierInfoWrap":"qempo_CourierInfoMini_courierInfoWrap-2PIqMIo","courierLogo":"qempo_CourierInfoMini_courierLogo-3g1i6Pv","textWrap":"qempo_CourierInfoMini_textWrap-1ohQsIQ","text":"qempo_CourierInfoMini_text-blrkcwX"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/order/Purchase/components/CourierInfoMini/CourierInfoMini.scss
// module id = 1845
// module chunks = 0